import { Component, OnInit, Input } from '@angular/core'
import { FolderService } from '../../folder.service'

@Component({
	selector: 'app-folder-view-mobile',
	templateUrl: './folder-view-mobile.component.html',
	styleUrls: ['./folder-view-mobile.component.scss']
})
export class FolderViewMobileComponent implements OnInit {

	@Input() folder: any
	fileInCenter

	constructor(
		public folderService: FolderService,
	) {}

	ngOnInit() {
	}

	ngOnChanges() {
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view-mobile/folder-view-mobile.component.ts